import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { RulesService } from "src/app/services/rules/rules.service";

@Component({
	selector: "app-confirm-delete-rule-dialog",
	templateUrl: "./confirm-delete-rule-dialog.component.html",
	styleUrls: ["./confirm-delete-rule-dialog.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class ConfirmDeleteRuleDialogComponent implements OnInit {
	constructor(public dialogRef: MatDialogRef<ConfirmDeleteRuleDialogComponent>, private rulesService: RulesService) {}

	ngOnInit(): void {}

	confirmDelete() {
		this.rulesService.confirmDeleteRules$.next();
		this.dialogRef.close();
	}
}
